import React from 'react'

import ReactDOM from 'react-dom'
import { Subject } from 'rxjs'

const container = document.querySelector('#app') || document.body;

export default (LayoutWrapper) => {
  const Render = new Subject()

  ReactDOM.render(
    <LayoutWrapper state={Render} />,
    container
  )

  return function (components = {}, pageData = {}, layoutData = {}) {
    Render.next({ components, pageData, layoutData })
  }
}